import React, { useEffect } from "react";
import Carousel from "../../ui/carousel/Carousel";
import useCarousel from "../../../hooks/ui/useCarousel";
import {
  AbsoluteNextArrow,
  AbsolutePrevArrow,
} from "../../ui/carousel/CarouselButton";
import { getFileUrl } from "../../../utils/helper";
import AOS from "aos";
import "aos/dist/aos.css";

const Hero = ({ imageList, content }) => {
  const { sliderRef, next, prev } = useCarousel();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <div className="relative bg-gradient-to-br from-orange-50 to-amber-50 overflow-hidden">
      <div className="sm:container sm:mx-auto sm:px-4 sm:py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row items-center lg:min-h-[600px] gap-8 lg:gap-12">
          
          {/* Content Section - Hidden on mobile if needed */}
         <div
  className="hidden lg:flex lg:w-1/2 flex-col justify-center space-y-6 px-4 lg:px-8"
  data-aos="fade-right"
>
  <div className="space-y-4">
    {/* Badge */}
    <span className="inline-block px-4 py-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-sm font-semibold rounded-full shadow-lg">
      {content?.badge || "Fresh Food Delivered"}
    </span>

    {/* Heading */}
    <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight">
      {content?.title || (
        <>
          Delicious Food from
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-600">
            My Canteen
          </span>
        </>
      )}
    </h1>

    {/* Description */}
    <p className="text-base lg:text-lg text-gray-600 leading-relaxed">
      {content?.description ||
        "Order fresh, hygienic, and tasty meals from your favorite local kitchens. Fast delivery, great prices, and a delightful food experience—every time."}
    </p>
  </div>

  {/* Buttons */}
  <div className="flex flex-wrap gap-4 pt-4">
    <button className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
      {content?.primaryButton || "Order Now"}
    </button>

    <button className="px-6 py-3 bg-white text-gray-800 font-semibold rounded-lg shadow-md hover:shadow-lg border-2 border-gray-200 hover:border-orange-500 transform hover:-translate-y-1 transition-all duration-300">
      {content?.secondaryButton || "Browse Restaurants"}
    </button>
  </div>

  {/* Features */}
  <div className="flex flex-wrap gap-6 pt-6 border-t border-gray-200">
    <div className="flex items-center gap-2">
      <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
      <span className="text-sm font-medium text-gray-700">
        Browse options - Explore counters
      </span>
    </div>

    <div className="flex items-center gap-2">
      <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
      <span className="text-sm font-medium text-gray-700">
        Verified Partner/Vendors
      </span>
    </div>

    <div className="flex items-center gap-2">
      <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
      <span className="text-sm font-medium text-gray-700">
        Secure Online Payment
      </span>
    </div>
  </div>
</div>


          <div 
            className="w-full lg:w-1/2 relative"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div className="relative sm:rounded-2xl overflow-hidden shadow-2xl bg-white">
              <AbsolutePrevArrow onClick={prev} />
              <AbsoluteNextArrow onClick={next} />
              
              <Carousel
                autoplay={true}
                sliderRef={sliderRef}
                slideToShow={1}
                fade={true}
                infinite={true}
                autoplaySpeed={4000}
              >
                {imageList.map((item, index) => (
                  <a key={index} href={item.link} className="block w-full relative group">
                    <div className="relative overflow-hidden aspect-video">
                      <img
                        src={getFileUrl(item.image)}
                        alt={`Slide ${index + 1}`}
                        className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      
                      {item.title && (
                        <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                          <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                          {item.subtitle && (
                            <p className="text-sm opacity-90">{item.subtitle}</p>
                          )}
                        </div>
                      )}
                    </div>
                  </a>
                ))}
              </Carousel>
              
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full blur-3xl opacity-30 animate-pulse"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-tr from-orange-400 to-amber-600 rounded-full blur-3xl opacity-30 animate-pulse delay-1000"></div>
            </div>

            <div className="flex justify-center gap-2 mt-6">
              {imageList.map((_, index) => (
                <div
                  key={index}
                  className="w-2 h-2 rounded-full bg-gray-300 hover:bg-orange-600 transition-colors cursor-pointer"
                />
              ))}
            </div>
          </div>

        </div>
      </div>

      <div className="absolute top-0 left-0 w-64 h-64 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
      <div className="absolute bottom-0 left-1/2 w-64 h-64 bg-orange-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
    </div>
  );
};

export default Hero;